export function rethrowError(err) {
  if (err instanceof Error) {
    throw err;
  }
  return err;
}